<script>
import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import PropertyTable from "../../common/property-table.vue";
import Loading from "../../common/loading.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import SelectField from "../../common/select-field.vue";
import API from "../../../API";
import toaster from "../../common/toaster";
import DialogButton from "../../dialog/components/dialog-button.vue";
import ConfirmDialog from "../../dialog/confirm-dialog.vue";

export default {
    name: "client-journal-filter-dialog",
    components: {
        ConfirmDialog,
        DialogButton,
        SelectField, DialogActionbar, Loading, PropertyTable, DialogHeader, TextField, DialogBase, DialogBody},
    data() {
        const name = Lang.langGet('Name');
        const mustEnter = Lang.langGet('You must enter a ');

        return {
            showDialog: false,
            showConfirmDeleteDialog: false,
            processing: false,
            invalid: true,
            name: '',
            clientName: '',
            dateFrom: undefined,
            dateTo: undefined,
            category: -1,
            type: -1,
            location: -1,
            locationGroups: [],
            id: null,

            stringRule: [
                function (value) {
                    if (value) {
                        return true;
                    }

                    return mustEnter + name;
                }
            ]
        }
    },
    computed: {
        filterCategories() {
            return Object.keys(Laravel.systemlog.category)
                .map(key => ({value: key, text: Laravel.systemlog.category[key]}))
                .concat({value: -1, text: '--Ignore--'})
                .sort((a, b) => a.value - b.value);
        },
        filterTypes() {
            return Object.keys(Laravel.systemlog.type)
                .map(key => ({value: key, text: Laravel.systemlog.type[key]}))
                .concat({value: -1, text: '--Ignore--'})
                .sort((a, b) => a.value - b.value);
        },
        translations() {
            const translate = (val) => Lang.langGet(val);

            return {
                privilegeName: translate('Privilege name'),
                addFilter: translate('Add new filter'),
                editFilter: translate('Edit filter'),
                filterName: translate('Filter name'),
                clientName: translate('Client name'),
                placeholder: translate('Enter a name'),
                name: translate('Name'),
                from: translate('From'),
                to: translate('To'),
                category: translate('Category'),
                location: translate('Filter by location'),
                type: translate('Type'),
                addedSuccessfully: Lang.langGet('Filter :name added successfully', {name: this.name}),
                deletedSuccessfully: Lang.langGet(
                    ":entityName was deleted successfully.",
                    {entityName: _.capitalize(this.name)}
                ),
                delete: translate('Delete'),
                confirmDeleteTitle: translate('Confirm delete'),
                confirmDeleteMessage: translate('Do you really want to delete the filter ') + this.name
            }
        },
    },
    methods: {
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },
        clear() {
            this.name = null;
            this.dateFrom = null;
            this.dateTo = null;
            this.category = -1;
            this.type = -1;
            this.location = -1;
        },
        refreshList() {
            EaseEventBus.fire('updateExistingFilters');
        },
        handleClose() { this.hide(); },
        handleChange(property, newValue) {
            this[property] = newValue;
        },
        handleShowConfirmDeleteDialog() {
            this.showConfirmDeleteDialog = true;
        },
        handleAbortDelete() {
            this.showConfirmDeleteDialog = false;
        },
        handleConfirmDelete() {
            this.showConfirmDeleteDialog = false;
            this.handleDelete();
        },
        async handleDelete() {
            this.processing = true;
            const url = '/system/client-journal/delete-filter';
            const api = new API(url);

            const result = await api.post({projectId: Laravel.activeProject, filterId: this.id});
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                toaster.success(this.translations.deletedSuccessfully);
                this.refreshList();
                this.hide();
            }
        },
        async handleSave() {
            this.processing = true;
            const url = '/system/client-journal/update-filter';
            const api = new API(url);

            const currentLocation = this.locationGroups.find(group => group.value === this.location);

            const data = {
                filters: {
                    type: this.type < 0 ? '' : this.type,
                    category: this.category < 0 ? '' : this.category,
                    name: this.clientName,
                    group: currentLocation ? currentLocation.latLong : "",
                    dateFrom: this.dateFrom || "",
                    dateTo: this.dateTo || ""
                },
                filterId: this.id,
                name: this.name,
                projectId: Laravel.activeProject
            };

            const result = await api.post(data)

            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                toaster.success(this.translations.addedSuccessfully);
                this.refreshList();
                this.hide();
                //workaround to not start a rewrite in the old codebase
                EaseEventBus.listen('loadedClientJournalFilter', () => {
                    EaseEventBus.fire('setNewClientJournalFilterAsCurrent', {name: this.name});
                })
            }
        },
        setLocationGroup(result) {
            this.locationGroups = result.groups
                .map((group, index) => {
                    const value = group.value ? index : -1;
                    return {value, latLong: group.value, text: group.label}
                });
        },
        setData(result) {
            const {name, dateFrom, dateTo, category, type, group} = result.filter;
            if (name) this.clientName = name;
            if (dateFrom) this.dateFrom = dateFrom;
            if (dateTo) this.dateTo = dateTo;
            if (category) this.category = category;
            if (type) this.type = type;
            if (group) {
                //findIndex returns -1 on failure which matches setLocationGroup if group is not set
                //necessary e.g. if group got deleted
                this.location = this.locationGroups.findIndex(element => element.latLong === group);
            }
        },
        async load() {
            this.processing = true;
            const url = '/system/client-journal/data-filter';
            const api = new API(url);

            const result = await api.post({projectId: Laravel.activeProject, filterId: this.id});
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                this.setLocationGroup(result);
                this.setData(result);
            }
        }
    },
    watch: {
        name(newName) {
            this.invalid = !newName;
        }
    },
    mounted: function () {
        EaseEventBus.listen('clientJournalFilterAdd', () => {
            this.id = -1;
            this.clear();
            this.show();
            this.load();
        });

        EaseEventBus.listen('clientJournalFilterEdit', params => {
            this.id = params.id;
            this.name = params.name;
            this.show();
            this.load();
        });
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="720"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <confirm-dialog v-if="showConfirmDeleteDialog"
            :title="translations.confirmDeleteTitle"
            :message="translations.confirmDeleteMessage"
            :showDialog="showConfirmDeleteDialog"
            @cancel="handleAbortDelete"
            @confirm="handleConfirmDelete"
            :no-icons="true"
        />
        <dialog-header
            @close="handleClose"
            :title="(id > 0) ? translations.editFilter : translations.addFilter"
        />
        <loading :loading="processing"/>
        <dialog-body>
            <div class="d-flex flex-row">
                <div class="d-flex flex-column w-50">
                    <text-field class="pa-4"
                        :label="translations.filterName"
                        :placeholder="translations.placeholder"
                        :value="name"
                        :rules="stringRule"
                        :error="invalid"
                        autofocus
                        @input="val => handleChange('name', val)"
                    />
                </div>
                <div class="d-flex flex-column w-50">
                    <select-field
                        class="pa-4"
                        :value="category"
                        @input="value => handleChange('category', value)"
                        :items="filterCategories"
                        :label="translations.category"
                    />
                </div>
            </div>

            <div class="d-flex flex-row">
                <div class="d-flex flex-column w-50">
                    <text-field class="pa-4"
                        :label="translations.clientName"
                        :value="clientName"
                        :placeholder="translations.placeholder"
                        @input="val => handleChange('clientName', val)"
                    />
                </div>
                <div class="d-flex flex-column w-50">
                    <select-field
                        class="pa-4"
                        :value="type"
                        @input="value => handleChange('type', value)"
                        :items="filterTypes"
                        :label="translations.type"
                    />
                </div>
            </div>

            <div class="d-flex flex-row">
                <div class="d-flex flex-column w-50">
                    <div class="d-flex flex-row pa-4">
                        <datepicker
                            :label="translations.from"
                            :value="dateFrom"
                            hide-details
                            popup-used-in-modal
                            @input="val => handleChange('dateFrom', val)"
                        />
                        <div class="ml-2">
                            <datepicker
                                :label="translations.to"
                                :value="dateTo"
                                hide-details
                                popup-used-in-modal
                                @input="val => handleChange('dateTo', val)"
                            />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column w-50">
                    <select-field
                        class="pa-4"
                        :value="location"
                        @input="value => handleChange('location', value)"
                        :items="locationGroups"
                        :label="translations.location"
                    />
                </div>
            </div>
        </dialog-body>
        <dialog-actionbar
            :disableSave="invalid"
            @close="handleClose"
            @save="handleSave"
        >
            <dialog-button color="secondary" @click="handleShowConfirmDeleteDialog">
                {{translations.delete}}
            </dialog-button>
        </dialog-actionbar>
    </dialog-base>
</template>

<style scoped>

</style>
